import { Component, OnInit, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';

import SurveyAnswer from 'entity/SurveyAnswer';
import SurveyQuestion from 'entity/SurveyQuestion';

import { AnswerService } from '../../services/answer.service';

@Component({
  selector: 'scale-survey-card',
  templateUrl: './scale-survey-card.component.html',
  styleUrls: ['./scale-survey-card.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScaleSurveyCardComponent implements OnInit {
  private _answerService = inject(AnswerService);

  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() public question?: SurveyQuestion;
  private answer?: SurveyAnswer;

  public ngOnInit(): void {
    this.answer = {
      surveyQuestionId: this.question?.surveyQuestionId,
      skipped: true,
    };
    this._answerService.trackAnswer(this.answer);
  }

  public valueSelected(e: MatRadioChange): void {
    const val = e.value;
    if (this.answer) {
      this.answer.answer = String(val);
      this.answer.skipped = false;
      this._answerService.trackAnswer(this.answer);
    }
  }
}
